"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('controllers/vehicleManagementController',["require", "exports", "providers/ajaxSettingsProvider", "controllers/abortingRequest"], function (require, exports, ajaxSettingsProvider, abortingRequest) {
    "use strict";

    var VehicleManagementController = function () {
        function VehicleManagementController() {
            _classCallCheck(this, VehicleManagementController);
        }

        _createClass(VehicleManagementController, [{
            key: "getOperationsCounts",
            value: function getOperationsCounts() {
                return abortingRequest.send('/api/VehicleManagement/GetOperationsCounts', ajaxSettingsProvider.httpGet(), false, false);
            }
        }, {
            key: "getVehicleManagementOperations",
            value: function getVehicleManagementOperations() {
                return abortingRequest.send('/api/VehicleManagement/GetVehicleManagementOperations', ajaxSettingsProvider.httpPost());
            }
        }, {
            key: "getExistingManufacturers",
            value: function getExistingManufacturers() {
                return abortingRequest.send('/api/VehicleManagement/GetExistingManufacturers', ajaxSettingsProvider.httpPost());
            }
        }, {
            key: "addNewManufacturer",
            value: function addNewManufacturer(request) {
                return abortingRequest.send('/api/VehicleManagement/AddNewManufacturer', ajaxSettingsProvider.httpPost(request));
            }
        }, {
            key: "associateWithManufacturer",
            value: function associateWithManufacturer(request) {
                return abortingRequest.send('/api/VehicleManagement/AssociateWithManufacturer', ajaxSettingsProvider.httpPost(request));
            }
        }, {
            key: "loadVariantGroupForManufacturer",
            value: function loadVariantGroupForManufacturer(request) {
                return abortingRequest.send('/api/VehicleManagement/LoadVariantGroupForManufacturer', ajaxSettingsProvider.httpPost(request));
            }
        }, {
            key: "addNewVariantGroup",
            value: function addNewVariantGroup(request) {
                return abortingRequest.send('/api/VehicleManagement/AddNewVariantGroup', ajaxSettingsProvider.httpPost(request));
            }
        }, {
            key: "addVariantToExistingVariantGroup",
            value: function addVariantToExistingVariantGroup(request) {
                return abortingRequest.send('/api/VehicleManagement/AddVariantToExistingVariantGroup', ajaxSettingsProvider.httpPost(request));
            }
        }, {
            key: "getGroupVariantsForModel",
            value: function getGroupVariantsForModel(request) {
                return abortingRequest.send('/api/VehicleManagement/GetGroupVariantsForModel', ajaxSettingsProvider.httpPost(request));
            }
        }, {
            key: "getGenerationsForGroup",
            value: function getGenerationsForGroup(request) {
                return abortingRequest.send('/api/VehicleManagement/GetGenerationsForGroup', ajaxSettingsProvider.httpPost(request));
            }
        }, {
            key: "saveModelGeneration",
            value: function saveModelGeneration(request) {
                return abortingRequest.send('/api/VehicleManagement/SaveModelGeneration', ajaxSettingsProvider.httpPost(request));
            }
        }, {
            key: "saveEditedGeneration",
            value: function saveEditedGeneration(request) {
                return abortingRequest.send('/api/VehicleManagement/SaveEditedGeneration', ajaxSettingsProvider.httpPost(request));
            }
        }, {
            key: "deleteModelGeneration",
            value: function deleteModelGeneration(request) {
                return abortingRequest.send('/api/VehicleManagement/DeleteModelGeneration', ajaxSettingsProvider.httpPost(request));
            }
        }, {
            key: "getPolicyVehicleStats",
            value: function getPolicyVehicleStats() {
                return abortingRequest.send('/api/VehicleManagement/GetPolicyVehicleStats', ajaxSettingsProvider.httpPost());
            }
        }, {
            key: "uploadManufacturerImage",
            value: function uploadManufacturerImage(imageFile, manufacturerName) {
                var ajaxSettings = ajaxSettingsProvider.httpPost(imageFile);
                ajaxSettings.settings.contentType = false;
                ajaxSettings.settings.processData = false;
                return abortingRequest.send('/api/VehicleManagement/UploadManufacturerImage/' + manufacturerName, ajaxSettings);
            }
        }, {
            key: "uploadModelImage",
            value: function uploadModelImage(imageFile, manufacturerName, variantGroupName) {
                var ajaxSettings = ajaxSettingsProvider.httpPost(imageFile);
                ajaxSettings.settings.contentType = false;
                ajaxSettings.settings.processData = false;
                return abortingRequest.send('/api/VehicleManagement/UploadModelImage/' + manufacturerName + '|' + variantGroupName, ajaxSettings);
            }
        }, {
            key: "uploadModelgenerationImage",
            value: function uploadModelgenerationImage(imageFile, manufacturerName, variantGroupName, generationNumber) {
                var ajaxSettings = ajaxSettingsProvider.httpPost(imageFile);
                ajaxSettings.settings.contentType = false;
                ajaxSettings.settings.processData = false;
                return abortingRequest.send('/api/VehicleManagement/UploadModelGenerationImage/' + manufacturerName + '|' + variantGroupName + '|' + generationNumber, ajaxSettings);
            }
        }]);

        return VehicleManagementController;
    }();

    return new VehicleManagementController();
});
//# sourceMappingURL=vehicleManagementController.js.map;
